import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './AdicionarCliente.css';
import Sidebar from './Sidebar'; // Ajuste o caminho se necessário
import FormularioCliente from '../Formulario/FormularioCliente';
import PopupImportacaoClientesEmMassa from '../Formulario/PopupImportacaoClientesEmMassa';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

// Função utilitária para fazer chamadas da API
const apiCall = async (endpoint, method = 'GET', data = null) => {
  const urls = [
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`
  ];

  for (const url of urls) {
    try {
      console.log(`Tentando conectar em: ${url}`);
      
      const options = {
        method,
        headers: {
          'Content-Type': 'application/json',
        }
      };
      const token = getAuthToken();
      if (token) options.headers['Authorization'] = `Bearer ${token}`;
      
      if (data && method !== 'GET') {
        options.body = JSON.stringify(data);
      }
      
      const response = await fetch(url, options);
      if (response.ok) {
        console.log(`✅ Sucesso em: ${url}`);
        return method === 'GET' ? await response.json() : response;
      }
      console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
    } catch (error) {
      console.log(`❌ Erro em: ${url} - ${error.message}`);
    }
  }
  
  throw new Error(`Nenhuma URL da API funcionou para ${method} ${endpoint}. Verifique se o backend está rodando.`);
};

function AdicionarCliente() {
  const location = useLocation();
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [mostrarImportacaoMassa, setMostrarImportacaoMassa] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [abrirSidebar, setAbrirSidebar] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [filtro, setFiltro] = useState('nome'); // Estado para o tipo de filtro
  const [valorFiltro, setValorFiltro] = useState(''); // Estado para o valor do filtro
  const [clientesFiltrados, setClientesFiltrados] = useState(clientes); // Estado para os clientes filtrados
  const [dropdownAberto, setDropdownAberto] = useState(false); // Estado para controlar o dropdown de filtro

  useEffect(() => {
    const buscarClientes = async () => {
      try {
        const dados = await apiCall('Cliente');
        console.log('=== DEBUG CLIENTES ===');
        console.log('Dados recebidos da API:', dados);
        console.log('Tipo dos dados:', typeof dados);
        console.log('É array?', Array.isArray(dados));
        console.log('Quantidade de itens:', dados?.length);
        
        if (dados && dados.length > 0) {
          console.log('Primeiro item:', dados[0]);
          console.log('Campos do primeiro item:', Object.keys(dados[0]));
        }

        setClientes(dados || []);
        setClientesFiltrados(dados || []); // Inicializa os clientes filtrados com todos os clientes

        // Se veio com editClienteId via navigation state, abrir edição automática
        const editId = location.state?.editClienteId;
        if (editId && dados && dados.length > 0) {
          try {
            const clienteDetalhado = await apiCall(`Cliente/${editId}`);
            setClienteSelecionado(clienteDetalhado);
            setAbrirSidebar(true);
          } catch (err) {
            console.error('Erro ao abrir cliente para edição:', err);
          }
        }
      } catch (error) {
        console.error('Erro ao carregar clientes:', error);
        setClientes([]);
        setClientesFiltrados([]);
      }
    };

    buscarClientes();
  }, [location.state]);

  // Listen for MobileFooter + button click on mobile
  useEffect(() => {
    const handler = () => setMostrarPopup(true);
    window.addEventListener('open-mobile-add-popup', handler);
    return () => window.removeEventListener('open-mobile-add-popup', handler);
  }, []);

  // Fecha todos os popups quando solicitado pelo AjudaWidget
  useEffect(() => {
    const handler = () => {
      setMostrarPopup(false);
      setMostrarImportacaoMassa(false);
      setDropdownAberto(false);
    };
    window.addEventListener('clientes-fechar-todos-popups', handler);
    return () => window.removeEventListener('clientes-fechar-todos-popups', handler);
  }, []);

  const adicionarCliente = async (novoCliente) => {
    try {
      // FormularioCliente já fez o POST - aqui só recarregamos a lista
      const clientesAtualizados = await apiCall('Cliente');
      setClientes(clientesAtualizados);
      setClientesFiltrados(clientesAtualizados);
      setClienteSelecionado(null);
      setMostrarPopup(false);
    } catch (error) {
      console.error('Erro ao recarregar clientes:', error);
    }
  };

  const editarCliente = async (index) => {
    const cliente = clientesFiltrados[index];
    const idCliente = cliente.Id || cliente.id || cliente.id_Clientes || cliente.clienteId;

    try {
      const clienteDetalhado = await apiCall(`Cliente/${idCliente}`);
      setClienteSelecionado(clienteDetalhado); // Atualiza o cliente selecionado
      setAbrirSidebar(false);
      setMostrarPopup(true); // Abre o popup de edição
    } catch (error) {
      alert(`Erro ao buscar cliente: ${error.message}`);
    }
  };

  const visualizarCliente = async (index) => {
    const cliente = clientesFiltrados[index];
    const idCliente = cliente.Id || cliente.id || cliente.id_Clientes || cliente.clienteId;

    try {
      const clienteDetalhado = await apiCall(`Cliente/${idCliente}`);
      setClienteSelecionado(clienteDetalhado); // Atualiza o cliente selecionado
      setAbrirSidebar(true); // Abre o Sidebar
    } catch (error) {
      alert(`Erro ao buscar cliente: ${error.message}`);
    }
  };

  const handleFiltroChange = (novoFiltro) => {
    setFiltro(novoFiltro);
    setValorFiltro(''); // Limpa o valor do input ao mudar o filtro
  };

  const handleInputChange = (e) => {
    const valor = e.target.value;
    setValorFiltro(valor);

    // Filtra os clientes dinamicamente usando os campos corretos do backend
    const filtrados = clientes.filter((cliente) => {
      if (filtro === 'nome') {
        const nome = cliente.Nome || cliente.nome || '';
        return nome.toLowerCase().includes(valor.toLowerCase());
      }
      if (filtro === 'id') {
        const id = cliente.Id || cliente.id || '';
        return id.toString() === valor;
      }
      if (filtro === 'celular') {
        const celular = cliente.Celular || cliente.celular || '';
        return celular.includes(valor);
      }
      if (filtro === 'email') {
        const email = cliente.Email || cliente.email || '';
        return email.toLowerCase().includes(valor.toLowerCase());
      }
      if (filtro === 'cpfCnpj') {
        const cpfCnpj = cliente.CPF_CNPJ || cliente.cpfCnpj || '';
        return cpfCnpj.includes(valor);
      }
      return true;
    });

    setClientesFiltrados(filtrados);
  };

  if (abrirSidebar) {
    return <Sidebar inicial="Cliente" clienteSelecionado={clienteSelecionado} />;
  }

  return (
    <div className="container-geral fundo-branco">
      <div className="header-adicionar" style={{ justifyContent: 'center', gap: 12 }}>
        <button
          className="btn-cadastro-massa"
          title="Cadastro em Massa via Excel"
          onClick={() => setMostrarImportacaoMassa(true)}
          style={{
            background: 'linear-gradient(135deg, #43a047, #2e7d32)',
            color: '#fff', border: 'none', borderRadius: 8,
            padding: '7px 14px', fontSize: 13, fontWeight: 700,
            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5,
            boxShadow: '0 2px 6px rgba(67,160,71,0.3)'
          }}
        >
          📥 Cadastro em Massa
        </button>
        <button className="botao-mais" onClick={() => { setClienteSelecionado(null); setAbrirSidebar(false); setMostrarPopup(true); }}>+</button>
      </div>

      {/* Campo de filtro */}
      <div className="filtro-container">
        <label className="filtro-label">Filtrar por:</label>
        <div className="filtro-input-container">
          <div className="filtro-input-wrapper">
            <input
              type="text"
              className="filtro-input"
              placeholder={`Filtrar por ${filtro}`}
              value={valorFiltro}
              onChange={handleInputChange}
            />
            {valorFiltro && (
              <button
                className="filtro-clear-button"
                onClick={() => setValorFiltro('')}
                title="Limpar filtro"
              >
                ×
              </button>
            )}
          </div>
          <div className="filtro-custom-select">
            <button
              className="filtro-custom-botao"
              onClick={() => setDropdownAberto(!dropdownAberto)}
            >
              {`Filtrar por ${filtro.charAt(0).toUpperCase() + filtro.slice(1)}`}
              <span className="seta-para-baixo">▼</span>
            </button>
            {dropdownAberto && (
              <div className="filtro-custom-opcoes">
                <div onClick={() => { handleFiltroChange('nome'); setDropdownAberto(false); }}>Filtrar por Nome</div>
                <div onClick={() => { handleFiltroChange('id'); setDropdownAberto(false); }}>Filtrar por ID</div>
                <div onClick={() => { handleFiltroChange('celular'); setDropdownAberto(false); }}>Filtrar por Celular</div>
                <div onClick={() => { handleFiltroChange('email'); setDropdownAberto(false); }}>Filtrar por Email</div>
                <div onClick={() => { handleFiltroChange('cpfCnpj'); setDropdownAberto(false); }}>Filtrar por CPF/CNPJ</div>
              </div>
            )}
          </div>
        </div>
      </div>



      {mostrarImportacaoMassa && (
        <PopupImportacaoClientesEmMassa
          onFechar={() => setMostrarImportacaoMassa(false)}
          onSucesso={async () => {
            try {
              const dados = await apiCall('Cliente');
              setClientes(dados || []);
              setClientesFiltrados(dados || []);
            } catch (e) {
              console.error('Erro ao recarregar clientes após importação:', e);
            }
          }}
        />
      )}

      {mostrarPopup && (
        <div className="popup-overlay">
          <div className="popup-conteudo">
            {/* Botão de fechar no canto superior direito */}
            <button 
              className="botao-fechar-popup"
              onClick={() => { setMostrarPopup(false); setClienteSelecionado(null); }}
              title="Fechar"
            >
              ×
            </button>
            
            {/* Conteúdo do formulário com margin-top para dar espaço ao botão fechar */}
            <div className="popup-formulario-container">
              <FormularioCliente
                cliente={clienteSelecionado}
                onSalvar={adicionarCliente}
                onCancelar={() => { setMostrarPopup(false); setClienteSelecionado(null); }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Lista de clientes filtrados */}
      <div className="clientes-cards-container">
        {clientesFiltrados.length === 0 && (
          <div className="agendamento-listagem-vazio">
            Nenhum cliente cadastrado.
            <br />
            <small>Debug: Total de clientes carregados: {clientes.length}</small>
          </div>
        )}
        
        {clientesFiltrados.map((cliente, index) => {
          // Usando os campos corretos do backend
          const idRaw = cliente.Id || cliente.id || cliente.id_Clientes || cliente.clienteId;
          const idCliente = idRaw ? idRaw.toString().padStart(6, '0') : 'SEM ID';
          const nome = cliente.Nome || cliente.nome || 'Sem nome';
          const celular = cliente.Celular || cliente.celular || 'Sem celular';
          const email = cliente.Email || cliente.email || 'Sem email';
          const cpfCnpj = cliente.CPF_CNPJ || cliente.cpfCnpj || cliente.cpF_CNPJ || 'Sem CPF/CNPJ';
          const tipoCliente = cliente.TipoPessoaDescricao || cliente.tipoPessoaDescricao || 'Não informado';
          const endereco = cliente.Endereco || cliente.endereco || 'Sem endereço';
          const cidade = cliente.Cidade || cliente.cidade || '';
          const uf = cliente.UF || cliente.uf || '';
          const enderecoCompleto = cidade && uf ? `${endereco} - ${cidade}/${uf}` : endereco;
          
          return (
            <div className="cliente-card" key={index} style={{borderLeft: '2.5px solid rgb(235, 133, 0)'}}>
              <div className="cliente-card-content">
                <div className="cliente-card-fields">
                  <div className="cliente-field cliente-field-id">
                    <label className="cliente-field-label">ID:</label>
                    <span className="cliente-field-value">{idCliente}</span>
                  </div>
                  
                  <div className="cliente-field cliente-field-nome">
                    <label className="cliente-field-label">Nome:</label>
                    <span className="cliente-field-value">{nome}</span>
                  </div>
                  
                  <div className="cliente-field cliente-field-tipo">
                    <label className="cliente-field-label">Tipo:</label>
                    <span className="cliente-field-value">{tipoCliente}</span>
                  </div>
                  
                  <div className="cliente-field cliente-field-cpf">
                    <label className="cliente-field-label">CPF/CNPJ:</label>
                    <span className="cliente-field-value">{cpfCnpj}</span>
                  </div>
                  
                  <div className="cliente-field cliente-field-celular">
                    <label className="cliente-field-label">Celular:</label>
                    <span className="cliente-field-value">{celular}</span>
                  </div>
                  
                  <div className="cliente-field cliente-field-email">
                    <label className="cliente-field-label">E-mail:</label>
                    <span className="cliente-field-value">{email}</span>
                  </div>
                  
                  <div className="cliente-field cliente-field-endereco">
                    <label className="cliente-field-label">Endereço:</label>
                    <span className="cliente-field-value">{enderecoCompleto}</span>
                  </div>
                </div>
              </div>
              
              <div className="cliente-card-actions">
                <button 
                  className="btn-editar-cliente" 
                  onClick={() => editarCliente(index)}
                >
                  Editar
                </button>
                <button 
                  className="btn-visualizar-cliente" 
                  onClick={() => visualizarCliente(index)}
                >
                  Visualizar
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function FormularioClienteWrapper({ onSalvar, onCancelar }) {
  const camposIniciais = {
    nome: '',
    celular: '',
    email: '',
    endereco: '',
    data_nasc: '',
    cidade: '',
    uf: '',
    bairro: '',
    cep: '',
    cpF_CNPJ: '',
    rg: '',
    regUnico: '',
    tipoPessoaId: null
  };

  const [valores, setValores] = useState(camposIniciais);
  const [erros, setErros] = useState({});
  const [tiposPessoa, setTiposPessoa] = useState([]);

  // Buscar tipos de pessoa da API
  useEffect(() => {
    const buscarTiposPessoa = async () => {
      try {
        const tipos = await apiCall('TipoPessoa');
        setTiposPessoa(tipos);
      } catch (error) {
        console.error('Erro ao buscar tipos de pessoa:', error);
      }
    };

    buscarTiposPessoa();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValores((prev) => ({ ...prev, [name]: value }));

    if (erros[name]) {
      setErros((prev) => {
        const copia = { ...prev };
        delete copia[name];
        return copia;
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const novosErros = {};
    
    // Validações obrigatórias
    if (!valores.nome.trim()) {
      novosErros.nome = 'Nome é obrigatório';
    }

    // Validação de email
    if (valores.email && !/\S+@\S+\.\S+/.test(valores.email)) {
      novosErros.email = 'E-mail inválido';
    }

    // Validação de celular
    if (valores.celular && !/^\d{11}$/.test(valores.celular)) {
      novosErros.celular = 'Celular deve conter 11 dígitos';
    }

    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      return;
    }

    // Preparar dados para envio (corresponde ao modelo do backend)
    const clienteParaApi = {
      nome: valores.nome,
      celular: valores.celular,
      email: valores.email,
      endereco: valores.endereco,
      data_nasc: valores.data_nasc,
      cidade: valores.cidade,
      uf: valores.uf,
      bairro: valores.bairro,
      cep: valores.cep,
      cpF_CNPJ: valores.cpF_CNPJ,
      rg: valores.rg,
      regUnico: valores.regUnico,
      tipoPessoaId: valores.tipoPessoaId ? parseInt(valores.tipoPessoaId) : null,
      dataCriacao: new Date().toISOString().split('T')[0]
    };

    onSalvar(clienteParaApi);
  };

  return (
    <form className="cliente-form-wrapper" onSubmit={handleSubmit}>
      {/* Botão de fechar */}
      <button
        type="button"
        className="cliente-form-btn-fechar"
        onClick={onCancelar}
      >
        ×
      </button>

      <h2 className="cliente-form-titulo">
        Adicionar Novo Cliente
      </h2>

      <div className="cliente-form-grid">
        {/* Nome */}
        <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label htmlFor="nome" style={{ marginBottom: '5px', fontWeight: '500' }}>Nome *</label>
          <input
            id="nome"
            type="text"
            name="nome"
            className="cliente-form-input"
            value={valores.nome}
            placeholder="Digite o nome completo"
            onChange={handleChange}
            required
          />
          {erros.nome && (
            <div style={{ color: 'red', fontSize: '0.8em', marginTop: '5px' }}>
              {erros.nome}
            </div>
          )}
        </div>
        
        {/* Celular */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="celular" style={{ marginBottom: '5px', fontWeight: '500' }}>Celular</label>
          <input
            id="celular"
            type="text"
            name="celular"
            className="cliente-form-input"
            value={valores.celular}
            placeholder="11999999999"
            onChange={e => {
              const onlyNums = e.target.value.replace(/\D/g, '');
              setValores((prev) => ({ ...prev, celular: onlyNums }));
            }}
            maxLength={11}
          />
          {erros.celular && (
            <div style={{ color: 'red', fontSize: '0.8em', marginTop: '5px' }}>
              {erros.celular}
            </div>
          )}
        </div>
        
        {/* Email */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="email" style={{ marginBottom: '5px', fontWeight: '500' }}>Email</label>
          <input
            id="email"
            type="email"
            name="email"
            className="cliente-form-input"
            value={valores.email}
            placeholder="email@exemplo.com"
            onChange={handleChange}
          />
          {erros.email && (
            <div style={{ color: 'red', fontSize: '0.8em', marginTop: '5px' }}>
              {erros.email}
            </div>
          )}
        </div>
        
        {/* Data de Nascimento */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="data_nasc" style={{ marginBottom: '5px', fontWeight: '500' }}>Data de Nascimento</label>
          <input
            id="data_nasc"
            type="date"
            name="data_nasc"
            className="cliente-form-input"
            value={valores.data_nasc || ''}
            onChange={handleChange}
          />
        </div>
        
        {/* CPF/CNPJ */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="cpF_CNPJ" style={{ marginBottom: '5px', fontWeight: '500' }}>CPF/CNPJ</label>
          <input
            id="cpF_CNPJ"
            type="text"
            name="cpF_CNPJ"
            className="cliente-form-input"
            value={valores.cpF_CNPJ || ''}
            placeholder="Digite apenas números"
            onChange={e => {
              const onlyNums = e.target.value.replace(/\D/g, '');
              setValores((prev) => ({ ...prev, cpF_CNPJ: onlyNums }));
            }}
            maxLength={14}
          />
        </div>
        
        {/* RG */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="rg" style={{ marginBottom: '5px', fontWeight: '500' }}>RG</label>
          <input
            id="rg"
            type="text"
            name="rg"
            className="cliente-form-input"
            value={valores.rg || ''}
            placeholder="Digite o RG"
            onChange={handleChange}
          />
        </div>
        
        {/* Registro Único */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="regUnico" style={{ marginBottom: '5px', fontWeight: '500' }}>Registro Único</label>
          <input
            id="regUnico"
            type="text"
            name="regUnico"
            className="cliente-form-input"
            value={valores.regUnico || ''}
            placeholder="Digite o Registro Único"
            onChange={handleChange}
          />
        </div>
        
        {/* Tipo de Pessoa */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="tipoPessoaId" style={{ marginBottom: '5px', fontWeight: '500' }}>Tipo de Pessoa</label>
          <select
            id="tipoPessoaId"
            name="tipoPessoaId"
            className="cliente-form-input"
            value={valores.tipoPessoaId || ''}
            onChange={handleChange}
          >
            <option value="">Selecione o tipo</option>
            {tiposPessoa.map(tipo => (
              <option key={tipo.id} value={tipo.id}>
                {tipo.descricaoTipoPessoa}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      {/* Seção de Endereço */}
      <div className="cliente-form-secao-titulo">
        <span>Endereço</span>
      </div>
      
      <div className="cliente-form-grid">
        {/* Endereço Completo */}
        <div style={{ display: 'flex', flexDirection: 'column', gridColumn: 'span 2' }}>
          <label htmlFor="endereco" style={{ marginBottom: '5px', fontWeight: '500' }}>Endereço Completo</label>
          <input
            id="endereco"
            type="text"
            name="endereco"
            className="cliente-form-input"
            value={valores.endereco || ''}
            placeholder="Rua, número, complemento"
            onChange={handleChange}
          />
        </div>
        
        {/* Bairro */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="bairro" style={{ marginBottom: '5px', fontWeight: '500' }}>Bairro</label>
          <input
            id="bairro"
            type="text"
            name="bairro"
            className="cliente-form-input"
            value={valores.bairro || ''}
            placeholder="Digite o bairro"
            onChange={handleChange}
          />
        </div>
        
        {/* Cidade */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="cidade" style={{ marginBottom: '5px', fontWeight: '500' }}>Cidade</label>
          <input
            id="cidade"
            type="text"
            name="cidade"
            className="cliente-form-input"
            value={valores.cidade || ''}
            placeholder="Digite a cidade"
            onChange={handleChange}
          />
        </div>
        
        {/* UF */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="uf" style={{ marginBottom: '5px', fontWeight: '500' }}>UF</label>
          <select
            id="uf"
            name="uf"
            className="cliente-form-input"
            value={valores.uf || ''}
            onChange={handleChange}
          >
            <option value="">Selecione</option>
            <option value="AC">AC</option>
            <option value="AL">AL</option>
            <option value="AP">AP</option>
            <option value="AM">AM</option>
            <option value="BA">BA</option>
            <option value="CE">CE</option>
            <option value="DF">DF</option>
            <option value="ES">ES</option>
            <option value="GO">GO</option>
            <option value="MA">MA</option>
            <option value="MT">MT</option>
            <option value="MS">MS</option>
            <option value="MG">MG</option>
            <option value="PA">PA</option>
            <option value="PB">PB</option>
            <option value="PR">PR</option>
            <option value="PE">PE</option>
            <option value="PI">PI</option>
            <option value="RJ">RJ</option>
            <option value="RN">RN</option>
            <option value="RS">RS</option>
            <option value="RO">RO</option>
            <option value="RR">RR</option>
            <option value="SC">SC</option>
            <option value="SP">SP</option>
            <option value="SE">SE</option>
            <option value="TO">TO</option>
          </select>
        </div>
        
        {/* CEP */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor="cep" style={{ marginBottom: '5px', fontWeight: '500' }}>CEP</label>
          <input
            id="cep"
            type="text"
            name="cep"
            className="cliente-form-input"
            // Guarda só os 8 números; exibe 00000-000
            value={(valores.cep || '').replace(/^(\d{5})(\d)/, '$1-$2')}
            placeholder="00000-000"
            onChange={e => {
              // Tira pontuação antes de limitar (maxLength 8 cortava o último número de "06395-000")
              const onlyNums = e.target.value.replace(/\D/g, '').slice(0, 8);
              setValores((prev) => ({ ...prev, cep: onlyNums }));
            }}
            maxLength={10}
          />
        </div>
      </div>
      
      <div className="cliente-form-botoes">
        <button 
          type="submit" 
          className="cliente-form-btn-salvar"
        >
          Salvar
        </button>
        <button 
          type="button" 
          className="cliente-form-btn-cancelar"
          onClick={onCancelar}
        >
          Cancelar
        </button>
      </div>
    </form>
  );
}

export default AdicionarCliente;